import { Withdrawal } from '@backend/JsonRpcApi';

export const getAddress = (item: Withdrawal) => {
  if (item.meta?.email) return item.meta?.email;
  if (item.meta?.account_id) return item.meta?.account_id;

  return item.address;
};
